'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { CouponIdContext } from './CouponIdContext.js';
/**
 * Provides the coupon id context to the component tree.
 * Used to set a specific coupon type for the application.
 *
 * @param root0 Component props
 * @param root0.children The children components to render
 * @returns Provider for {@link CouponIdContext}
 */
export function CouponIdProvider({ children }) {
    // Keep type in reference for now, change to state when required
    const typeRef = useRef(undefined);
    const getType = () => typeRef.current;
    const setType = (type) => {
        typeRef.current = type;
    };
    const value = useMemo(() => ({
        getType,
        setType,
    }), []);
    return _jsx(CouponIdContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=CouponIdProvider.js.map